module.exports = __webpack_public_path__ + "static/media/difitek-architecture.200c6a85.png";